module.exports = __webpack_public_path__ + "img/icon_traffic@2x.bbb07f68.png";